"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTravelExpensesSubformResults = void 0;
const utils_1 = require("../carUsage/utils");
const utils_2 = require("../utils");
const PRIVATE_CAR_USAGE_RATE_IN_CENTS = 30;
const calculateTravelExpensesSubformResults = (inputs, declarationYear) => {
    if (declarationYear < 2019) {
        throw new Error("Invalid declaration year");
    }
    (0, utils_2.validateAmounts)(Object.values(inputs));
    const { commuteDistance, commuteDays, privateCarTravelDistance, additionalMealExpenses } = inputs;
    const privateCarUsageContribution = privateCarTravelDistance * PRIVATE_CAR_USAGE_RATE_IN_CENTS;
    const minDeductibleTravelExpenses = (0, utils_1.getMinDeductibleTravelExpenses)({ commuteDays, commuteDistance, declarationYear });
    const profitReduction = privateCarUsageContribution + additionalMealExpenses + minDeductibleTravelExpenses;
    return {
        privateCarUsageContribution,
        additionalMealExpenses,
        minDeductibleTravelExpenses,
        profitReduction,
    };
};
exports.calculateTravelExpensesSubformResults = calculateTravelExpensesSubformResults;
//# sourceMappingURL=default.js.map